const calc = require('./src/calc');
const claims = require('./src/claims');
const ShiftCheckerModule = require('./src/ShiftChecker');
const validation = require('./src/validation');
const dateFormat = require('./src/date.format');
const reportHelpers = require('./src/report-helpers');
const cognitoFields = require('./src/const/cognitoFields');
const authModules = require('./src/const/authModules');
const winstonLogger = require('./src/logger');
const consoleLog = require('./src/consoleLog');
const printerHelper = require('./src/printerHelper');
const federatedIdentityInfo = require('./src/const/federatedIdentityInfo');
const stageInfo = require('./src/const/stageInfo');
// NOTE: this is *not* the commonjs version
module.exports = {
  calc,
  claims,
  ShiftChecker: ShiftCheckerModule.ShiftChecker,
  validation,
  dateFormat,
  reportHelpers,
  cognitoFields,
  authModules,
  // logger: winstonLogger.logger,
  createMyLogger: winstonLogger.createMyLogger,
  consoleLog,
  printerHelper,
  federatedIdentityInfo,
  stageInfo
};
